import { PageWrapper, Tabs } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { ReactComponent as ActivityProgramIcon } from 'App/assets/img/activity-program.svg';
import { ReactComponent as HraIcon } from 'App/assets/img/hra-icon.svg';
import { ReactComponent as PopulationIcon } from 'App/assets/img/population.svg';
import { ReactComponent as RiskGroupIcon } from 'App/assets/img/risk-group.svg';
import { Fragment, useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActivityProgram } from './components/ActivityProgram/ActivityProgram';
import { Population } from './components/Population/Population';
import { RiskGroup } from './components/RiskGroups/RiskGroups';
import {
	HealthRiskAssessmentContext,
	HealthRiskAssessmentContextType,
} from './HealthRiskAssessment.context';
import { Footer, Wrapper } from './HealthRiskAssessment.styles';
import {
	RiskAssessmentGroupTypes,
	TabType,
} from './HealthRiskAssessment.types';

export const HealthRiskAssessment = (): JSX.Element => {
	const navigate = useNavigate();
	const { setSelectedGroup } = useContext<HealthRiskAssessmentContextType>(
		HealthRiskAssessmentContext,
	);
	const [active, setActive] = useState<number>(0);

	const tabs = [
		{ name: 'Grupos de riesgo', icon: <RiskGroupIcon /> },
		{ name: 'Población', icon: <PopulationIcon /> },
		{ name: 'Programa de actividades', icon: <ActivityProgramIcon /> },
	];

	const handleChangeTab = (group: RiskAssessmentGroupTypes, tab: TabType) => {
		const mappedTabs = {
			riskGroup: 0,
			population: 1,
			activityProgram: 2,
		};

		setSelectedGroup(group);
		setActive(mappedTabs[tab]);
	};

	const returnToMenu = () => {
		navigate('/');
	};

	const components = useMemo(
		() => [
			{
				id: 0,
				content: <RiskGroup onChangeTab={handleChangeTab} />,
			},
			{
				id: 1,
				content: <Population />,
			},
			{
				id: 1,
				content: <ActivityProgram />,
			},
		],
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[active],
	);

	return (
		<Wrapper>
			<PageWrapper
				icon={<HraIcon color="#b2b6c0" />}
				title="Health Risk Assessment"
			>
				<Fragment>
					<Tabs
						initialActiveTab={active}
						side="right"
						tabItems={tabs}
						onChange={(tab) => setActive(tab)}
						height="100%"
						width="100%"
						overflow="hidden"
						className="tabs-container"
					/>
					{components[active].content}
				</Fragment>
				<Footer>
					<Button variant="outline" width="200px" onClick={returnToMenu}>
						Ir al menu principal
					</Button>
				</Footer>
			</PageWrapper>
		</Wrapper>
	);
};
